<template>
  <div ref='chart' class='mvp-daily-chart' :style='{ height: `${height}px` }' />
</template>

<script>
import * as echarts from 'echarts/core'
import { BarChart } from 'echarts/charts'
import { GridComponent, TooltipComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import moment from 'moment'

echarts.use([BarChart, GridComponent, TooltipComponent, CanvasRenderer])

export default {
  name: 'MvpDailyChart',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    height: {
      type: Number,
      default: 240
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    data() {
      this.render()
    }
  },
  methods: {
    render() {
      if (!this.chart) {
        return
      }
      const barStyle = { barMaxWidth: 14, itemStyle: { borderRadius: [2, 2, 0, 0] } }
      this.chart.setOption({
        color: ['#00537b', '#04a7f3'],
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: 32, right: 8, top: 12, bottom: 28 },
        xAxis: {
          type: 'category',
          data: this.data.map((day) => moment(day.date, 'YYYY-MM-DD').format('DD/MM')),
          axisTick: { show: false },
          axisLine: { lineStyle: { color: '#cfd6e0' } },
          axisLabel: { color: '#808080', fontSize: 12 }
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
          axisLabel: { color: '#808080', fontSize: 12 },
          splitLine: { lineStyle: { color: '#eef1f6' } }
        },
        series: [
          { name: 'Acessos', type: 'bar', data: this.data.map((day) => day.views), ...barStyle },
          { name: 'Usuários únicos', type: 'bar', data: this.data.map((day) => day.uniqueUsers), ...barStyle }
        ]
      })
    },
    resize() {
      if (this.chart) {
        this.chart.resize()
      }
    }
  },
  mounted() {
    this.chart = echarts.init(this.$refs.chart)
    this.render()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  }
}
</script>

<style lang='scss' scoped>
.mvp-daily-chart {
  width: 100%;
}
</style>
